import { ReactElement } from "react";
import { Outlet, Navigate, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { Typography as T } from "@mui/material";
import { LOGIN, adminLoginFullPath, employeeLoginFullPath } from "./paths";
import useGetMe from "../hooks/queries/useGetMe";
import AuthService from "../api/services/AuthService";

// This is a wrapper to protect employee routes and avoid admins from trying to access w/o the right setup
const EmployeeRoleRequired = ({
  children,
}: {
  redirectPath?: string;
  children?: ReactElement;
}) => {
  const { data, status } = useGetMe();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  if (status === "loading") return null;
  if (status === "error") return <Navigate to={`/${LOGIN}`} replace />;

  const handleLogout = async () => {
    await queryClient.invalidateQueries();
    AuthService.logout();
    navigate(employeeLoginFullPath);
  };

  const role = data.role;
  if (data && role !== "employee") {
    const text =
      role === "admin"
        ? "You are logged in as an admin"
        : "You do not have employee permissions";
    return (
      <div className="flex flex-col items-center justify-center w-100 h-screen">
        <div className="w-50">
          <>
            <T variant="lgMed">{text}</T>
            <div className="mt-16">
              <T>
                If you want to continue as an admin, go{" "}
                <Link to={adminLoginFullPath}>here.</Link>
              </T>
              <T>
                If want to log in with your employee account, go{" "}
                <span onClick={handleLogout} className="link">
                  here.
                </span>
              </T>
            </div>
          </>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default EmployeeRoleRequired;
